import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [Email, setEmail] = React.useState(FetchData.meta.email)
  const [Phone, setPhone] = React.useState(FetchData.meta.phone)
  const [UserName, setUserName] = React.useState(FetchData.meta.username)
  const [Photo, setPhoto] = React.useState(FetchData.meta.photo)
  const [Role, setRole] = React.useState(FetchData.meta.role)
  const [Permission, setPermission] = React.useState(FetchData.meta.permission)
  const [IsActive, setIsActive] = React.useState(FetchData.meta.is_active)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")


  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "name": `${Title}`,
        "email": `${Email}`,
        "phone": `${Phone}`,
        "photo": `${Photo}`,
        "is_active": `${IsActive}`,
        "role": `${Role}`,
        "permission": `${Permission}`
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_user_data)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Batch Added Successfully")
          history.push(`${slugs.batch_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_user_data, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  useEffect(() => {

  }, [])

  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Batch Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Email</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Email} placeholder="Email"
                    onChange={(event) => { setEmail(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Phone</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Phone} placeholder="Phone Number"
                    onChange={(event) => { setPhone(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Role</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Role} placeholder="Role"
                    onChange={(event) => { setRole(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Is Active</td>
                <td className="col-6">
                  <input className="input-common"
                    value={IsActive} placeholder="Is Active"
                    onChange={(event) => { setIsActive(event.target.value) }}
                  />
                </td>
              </tr>
              {/* <tr>
                <td className="col-3">Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Name} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr> */}
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Users
              </div>
            </div>
          </div>
        </div>
      </div >

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div >
  )

}